import "./styles.css";

import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { ReactNode } from "react";
import ExampleTheme from "./themes/ImoovaTheme";
import { PlainTextPlugin } from "@lexical/react/LexicalPlainTextPlugin";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { LexicalErrorBoundary } from "@lexical/react/LexicalErrorBoundary";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import {
  $createParagraphNode,
  $createTextNode,
  $getRoot,
  Klass,
  LexicalNode,
} from "lexical";
import { cn } from "@/lib/utils";

interface PlainTextEditorProps {
  className?: string;
  children?: ReactNode;
  initialHtml?: string;
  name?: string;
  nodes?: Array<Klass<LexicalNode>>;
}
export function PlainTextEditor({
  children,
  className,
  initialHtml = "",
  name = "text",
  nodes = [],
}: PlainTextEditorProps) {
  const editorConfig = {
    namespace: name,
    theme: ExampleTheme,
    nodes,
    onError(error: any) {
      throw error;
    },
    editorState: () => {
      const root = $getRoot();
      const textNode = $createTextNode(initialHtml);
      const paragraphNode = $createParagraphNode();
      paragraphNode.append(textNode);
      root.append(paragraphNode);
    },
  };

  return (
    <LexicalComposer initialConfig={editorConfig}>
      <div className="relative">
        <PlainTextPlugin
          contentEditable={<ContentEditable className={cn(className)} />}
          placeholder={<Placeholder />}
          ErrorBoundary={LexicalErrorBoundary}
        />
        <HistoryPlugin />

        <div className="editor-inner">{children}</div>
      </div>
    </LexicalComposer>
  );
}

function Placeholder() {
  return <div className="editor-placeholder" />;
}
